export const appleAuth = {};

export const AppleButton = () => null;

AppleButton.Style = {};
AppleButton.Type = {};
